function helperStringLowerCase (str) {
  return str.toLowerCase()
}

module.exports = helperStringLowerCase



//////////////////
// WEBPACK FOOTER
// ./~/.store/xe-utils@3.5.27/~/xe-utils/helperStringLowerCase.js
// module id = 441
// module chunks = 75